<template>
    <div class="about">
        <v-header />
        <v-sidebar />
        <div class="content-box" >
            <div class="content">
                <div>
                    <div class="crumbs">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item>
                                <i class="el-icon-paperclip"></i> 待审核用户
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="container">
                        <div class="handle-box">
                            <el-input v-model="query.unameLike" placeholder="用户名" class="handle-input mr10"></el-input>
                            <el-input v-model="query.rnameLike" placeholder="姓名" class="handle-input mr10"></el-input>
                            <el-input v-model="query.mobileLike" placeholder="手机号" class="handle-input mr10"></el-input>
                            <el-input v-model="query.emailLike" placeholder="邮箱" class="handle-input mr10"></el-input>
                            <el-date-picker
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    v-model="query.regTs"
                                    type="date"
                                    placeholder="注册日期">
                            </el-date-picker>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="handleSearchClear">清空搜索条件</el-button>

                            <br>
                            <el-button type="primary" icon="el-icon-check" @click="handlePL(1)">批量审核通过</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="handlePL(-1)">批量不通过</el-button>

                        </div>
                        <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header" @selection-change="handleSelectionChange"  size="mini">
                            <el-table-column  type="selection"   width="55"> </el-table-column>
                            <el-table-column prop="id" label="ID" width="100" align="center"></el-table-column>
                            <el-table-column  label="注册信息"  align="left"  >
                                <template #default="scope">
                                <p><b>用户名：</b>{{scope.row.uname}}<el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='用户名不真实')">用户名不真实</el-tag></p>
                                <p><b>姓名：</b>{{scope.row.rname}} <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='姓名不真实')">姓名不真实</el-tag></p>
                                <p><b>邮箱：</b>{{scope.row.email}}  <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='邮箱不真实')">邮箱不真实</el-tag></p>
                                <p><b>手机号：</b> ({{scope.row.countryMobile}} {{scope.row.quhaoMobile}}){{scope.row.mobile}}
                                    <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='手机号不真实')">手机号不真实</el-tag></p>
                                <p><b>常住地址：</b>{{scope.row.address}}
                                    <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='常住地址不真实')">常住地址不真实</el-tag></p>
                                <p><b>注册时间：</b>{{scope.row.regTs}}</p>
                                    <p>
                                        <el-button type="primary" icon="el-icon-check"
                                                   @click="handlePass(scope.$index, scope.row)">审核通过
                                        </el-button>
                                        <el-button type="danger" icon="el-icon-close"
                                                   @click="handleNotPass(scope.$index, scope.row)">不通过
                                        </el-button>
                                    </p>

                                    <el-input @keyup.enter.native="handleNotPass(scope.$index, scope.row)" type="textarea" v-model="scope.row.shMsg"  placeholder="请输入不通过原因，按enter健提交"></el-input>

                                    <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='用户名不真实')">用户名不真实</el-tag>
                                    <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='姓名不真实')">姓名不真实</el-tag>
                                    <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='邮箱不真实')">邮箱不真实</el-tag>
                                    <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='手机号不真实')">手机号不真实</el-tag>
                                    <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='常住地址不真实')">常住地址不真实</el-tag>
                                    <el-tag type="danger" @click="handleNotPass(scope.$index, scope.row,shMsg='最近照片不真实')">最近照片不真实</el-tag>

                                </template>
                            </el-table-column>

                            <el-table-column label="最近照片"   align="center">
                                <template #default="scope">
                                    <p> <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='最近照片不真实')">最近照片不真实</el-tag>
                                    </p>
                                    <img :src="scope.row.pimg" style="max-width:300px;"  >
                                   <p> <el-tag  @click="handleNotPass(scope.$index, scope.row,shMsg='最近照片不真实')">最近照片不真实</el-tag>
                                   </p>

                                </template>
                            </el-table-column>




                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handlePageChange"
                                    :current-page="query.pageNo"
                                    :page-sizes="[10,20,30]"
                                    :page-size="query.pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="pageTotal">
                            </el-pagination>
                        </div>

                        <div>
                            <el-button type="primary" icon="el-icon-check" @click="handlePL(1)">批量审核通过</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="handlePL(-1)">批量不通过</el-button>

                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vHeader from "./Header.vue";
    import vSidebar from "./Sidebar.vue";
    import {
        admin_wait_sh_users_page,
        admin_users_shpass,
        admin_users_shnotpass,
        admin_users_shPL,
        admin_users_getWaitShNum
    } from '../../api';
    import {dealResult} from "../../api/common";
    export default {
        name: "AdminWaitShUsers",
        components: {
            vHeader,
            vSidebar,
        },
        data() {
            return {
                tableData: [],
                query :{
                    regTs: '',
                    rnameLike: '',
                    unameLike: '',
                    phoneLike: '',
                    emailLike: '',
                    pageNo: 1,
                    pageSize: 10,
                },
                pageTotal: 0,
                editVisible: false,
                lander:{},

                multipleSelection:[],//批量



            };
        },
        methods:{
            getWaitShNum(){
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                };
                admin_users_getWaitShNum(o).then((res) => {

                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$store.dispatch('saveWaitShUserNum',res.data.obj);

                    }
                })
            },
            handlePL(role){
                console.log(this.multipleSelection)
                if(this.multipleSelection.length==0){
                    this.$message.info("请选择数据");return;
                }
                this.loading = this.$loading({
                    lock: true,
                    text: "请求中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
                let ids='';
                for(let i=0;i<this.multipleSelection.length;i++){
                    ids+=this.multipleSelection[i].id+",";
                }

                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    role:role,
                    ids:ids
                };
                admin_users_shPL(o).then((res) => {
                    this.loading.close();
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("操作成功");

                        this.query.pageNo=1;
                        this.getPage();
                        this.getWaitShNum();

                    }
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            handleSearchClear(){
                this.query.regTs='';
                this.query.unameLike='';
                this.query.rnameLike='';
                this.query.mobileLike='';
                this.query.emailLike='';
                this.query.pageNo = 1;
                this.getPage();
            },
            // 查询操作
            handleSearch (){
                console.log(this.query)
                this.query.pageNo = 1;
                this.getPage();
            },

            // 分页导航
            handlePageChange (val) {
                this.query.pageNo = val;
                this.getPage();
            },
            handleSizeChange(val) {
                this.query.pageNo = 1;
                this.query.pageSize = val;
                this.getPage();
            },



            //审核通过
            handlePass(index,row){
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    id:row.id
                };
                this.tableData.splice(index,1);//放到这里方便快速审核
               admin_users_shpass(o).then((res) => {
                   dealResult(res.data);
                   if (res.data.status == 1) {
                       this.$message.success("操作成功");
                       this.getWaitShNum();

                       if(this.tableData.length==0){
                           this.query.pageNo=1;
                           this.getPage();
                       }
                   }else{
                       this.$message.info(res.data.msg);
                   }
               })
            },
            //审核不通过
            handleNotPass(index,row){
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    id:row.id,
                    shMsg:row.shMsg
                };
                this.tableData.splice(index,1);
                admin_users_shnotpass(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("操作成功");
                        this.getWaitShNum();

                        if(this.tableData.length==0){
                            this.query.pageNo=1;
                            this.getPage();
                        }
                    }else{
                        this.$message.info(res.data.msg);
                    }
                })
            },
            //获取列表数据
            getPage(){
                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                admin_wait_sh_users_page(this.query).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.tableData = res.data.obj.list
                        this.pageTotal = res.data.obj.total//该页总共多少条记录
                    }

                })
                this.getWaitShNum();
            },

        },
        mounted() {
            this.lander = JSON.parse(this.$store.state.logininfo);
            this.getPage()

        }
    }
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .table {
        width: 100%;
        font-size: 14px;
    }
    .red {
        color: #ff0000;
    }
    .mr10 {
        margin-right: 10px;
        width:150px;
    }
    /*滚动条的宽度*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 10px;
    }
    /*滚动条滑块*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: #409eff;
        /*border-radius: 3px;*/
    }
</style>
